import Banner from "@/components/landing/fee/Banner";
import FessContent from "@/components/landing/fee/FessContent";

export default function Fees() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Fess Content section */}
      <FessContent />
    </>
  );
}
